<div class="timeline-root"
     infinite-scroll
     [infiniteScrollDistance]="0.1"
     [scrollWindow]="false"
     [immediateCheck]="true"
     *transloco="let t">
  <div *ngFor="let item of timelineItems; index as i" class="timeline">
    <app-month-expansion-panel content [date]="item.date">
      <div class="transactions" *ngFor="let group of item.transactions">
        <div class="transaction-area">
          <app-transaction-card content
                                [quantity]="group.totalPoints"
                                [transactionType]="group.transactionType"
                                [expirationDate]="group.expirationDate"
                                [user]="group.userName"
                                [generationDate]="group.generationDate"
                                [transactions]="group.transactions"></app-transaction-card>
        </div>
      </div>
    </app-month-expansion-panel>
  </div>
  <mat-spinner diameter="15"
               [ngClass]="{hidden: !loading}">
  </mat-spinner>
  <div *ngIf="timelineItems && !timelineItems.length && !loading" class="empty">
    <app-empty-feed
      icon="list_alt"
      header="{{t('empty-points-transaction')}}"
      text="{{t('feed-not-listed-description')}}">
    </app-empty-feed>
  </div>
</div>
